import { useEffect, useState } from "react";
import { Get, Set } from "../../../../Request";

export const useOutsideHandle = (ref, method = () => {}) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        method();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
};

export const useUploadImage = (form, setForm) => {
  const [loadingUpload, setLoadingUpload] = useState(false);
  const uploadImg = async () => {
    setLoadingUpload(true);
    await Set({
      url: "/uploadImage",
      data: { image: form.image },
      neddata: true,
    }).then(res => {
      setForm({
        ...form,
        values: [
          ...form.values,
          {
            tag: form.kind,
            currentValue: form.value,
            value: res[0],
            style: {
              maxWidth: "100%",
              height: "auto",
            },
            id: form.id,
            nested: [],
            alt: form.alt,
          },
        ],
        modal: false,
        id: form.id + 1,
      });
      setLoadingUpload(false);
    });
  };
  return { uploadImg };
};
